import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { hybridStoresOffer as orgConfig } from 'org/configs/modules.config';

export const defaultConfig = {
  defaults: {
    rebateOptions: {
      hideRebatePrefix: false,
      hideElevationCurrency: true,
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
